import React from 'react';
import { useDrop } from 'react-dnd';
import { ItemType } from './DraggableCode';

const BackgroundDropZone = ({ onDrop, children, t }) => {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: ItemType,
        drop: (item, monitor) => {
            // Only ungroup if dropped on background (not intercepted by parent)
            // This means child codes dropped anywhere except on parents become parents
            if (item.code.parent && !monitor.didDrop()) {
                onDrop(item.code, null); // Ungroup - make it a parent
            }
        },
        canDrop: (item) => !!item.code.parent, // Only child codes can be ungrouped
        collect: (monitor) => ({
            isOver: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop(),
        }),
    }), [onDrop]);

    return (
        <div
            ref={drop}
            className={`relative min-h-96 ${
                isOver && canDrop
                    ? 'bg-red-50 border-2 border-red-300 border-dashed rounded-lg'
                    : ''
            }`}
            style={{ minHeight: '400px' }}
        >
            {isOver && canDrop && (
                <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-2 rounded-lg shadow-lg font-semibold z-10">
                    <div className='flex items-center gap-2'>
                        <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                            <path fillRule='evenodd' d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z' clipRule='evenodd' />
                        </svg>
                        {t('DetailProjects.Drop here to make parent')}
                    </div>
                </div>
            )}
            {children}
        </div>
    );
};

export default BackgroundDropZone;